var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreece(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 39.9999C31.0457 39.9999 40 31.0456 40 19.9999C40 8.95422 31.0457 -8.02875e-05 20 -8.02875e-05C8.9543 -8.02875e-05 0 8.95422 0 19.9999C0 31.0456 8.9543 39.9999 20 39.9999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 14.7825H39.311C38.8095 12.922 38.0473 11.1688 37.0645 9.56509H20V14.7825Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.55019 35.6522H32.4496C34.2749 34.1984 35.8402 32.4326 37.0644 30.4347H2.93542C4.15972 32.4326 5.72503 34.1984 7.55019 35.6522V35.6522Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.95644 4.83898C5.38409 6.19297 4.0248 7.78742 2.93542 9.56523H6.95644V4.83898Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 20C19.9999 17.9628 19.9999 16.2578 19.9999 14.7825H12.1738V20H6.95636V14.7825H0.688862C0.240503 16.4461 -0.00012207 18.1947 -0.00012207 20C-0.00012207 21.8052 0.240503 23.5538 0.688862 25.2174H39.311C39.7593 23.5538 39.9999 21.8052 39.9999 20H19.9999Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 -4.91738e-05C17.2227 -4.91738e-05 14.5777 0.566591 12.1738 1.58964V9.56519H19.9999C19.9999 7.74393 19.9999 6.19495 19.9999 4.34776H32.4497C29.0332 1.62683 24.7069 -4.91738e-05 19.9999 -4.91738e-05V-4.91738e-05Z",
    fill: "#338AF3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_462"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreece);
export default __webpack_public_path__ + "static/media/greece.59f6d5e3a19e9b4ba12b08c019e2ad23.svg";
export { ForwardRef as ReactComponent };